import dayjs from 'dayjs';
import isoWeek from 'dayjs/plugin/isoWeek';
import { useQuery } from 'react-query';

import { useReportScope } from '@ge/feat-reporting/hooks/use-report-scope';
import { WidgetNames } from '@ge/feat-reporting/models/widgets';
import { EntityType, QueryKey } from '@ge/models/constants';
import { DateTimeFormats } from '@ge/models/constants';
import { Config } from '@ge/shared/data-hooks';
import { fetchReferencePeriodKpiDate } from '@ge/shared/services/kpi';

dayjs.extend(isoWeek);
export const useWidgetReferenceHistory = ({
  endDate: _endDate,
  isActive = true,
  name,
  startDate: _startDate,
}) => {
  const { siteIds, scope, scopeType } = useReportScope();
  let endDate = _endDate;
  let startDate = _startDate;
  const siteId =
    scopeType === EntityType.CONTRACT ? scope?.contractId : siteIds?.length ? siteIds[0] : '';
  const reportType = scopeType === EntityType.CONTRACT ? EntityType.CONTRACT : EntityType.SITE;

  if (name === WidgetNames.REFERENCE_PERIOD_HISTORY) {
    // Backend endpoint for this data will return an error if any future dates are passed
    const currentDate = dayjs();
    if (dayjs(endDate) > currentDate) {
      endDate = currentDate;
    }
    if (dayjs(startDate) > currentDate) {
      startDate = currentDate;
    }
  }

  const params = {
    siteId,
    reportType,
    startDate: dayjs(startDate).format(DateTimeFormats.ENDPOINT_PARAM),
    endDate: dayjs(endDate).format(DateTimeFormats.ENDPOINT_PARAM),
  };
  const {
  data: _data,
  error,
  isLoading,
} = useQuery(
  [QueryKey.REFERENCE_PERIOD_HISTORY, params],
  () => fetchReferencePeriodKpiDate(params),
  {
    ...Config.EXECUTE_ONCE,
    enabled: isActive,
  },
);
  // const _data = {
  //   seriesData: {
  //     columns: [
  //       'Reference Period',
  //       'Contractual Availability',
  //       'Actual Production',
  //       'Loss Production',
  //     ],
  //     contractName: 'São Clemente',
  //     contractType: 'latam-tba',
  //     data: [
  //       {
  //         actualProduction: '-',
  //         availableTime: '-',
  //         contractualAvailability: '-',
  //         lostProduction: '-',
  //         referencePeriod: null,
  //         unavailableTime: '-',
  //       },
  //       {
  //         actualProduction: '-',
  //         availableTime: '90928.15',
  //         contractualAvailability: '97.17',
  //         lostProduction: '-',
  //         referencePeriod: 'May 2026',
  //         unavailableTime: '2586.86',
  //       },
  //       {
  //         actualProduction: '-',
  //         availableTime: '88521.59',
  //         contractualAvailability: '97.79',
  //         lostProduction: '-',
  //         referencePeriod: 'Jun 2026',
  //         unavailableTime: '963.44',
  //       },
  //       {
  //         actualProduction: '-',
  //         availableTime: '90101.66',
  //         contractualAvailability: '96.33',
  //         lostProduction: '-',
  //         referencePeriod: 'Jul 2026',
  //         unavailableTime: '1369.84',
  //       },
  //       {
  //         actualProduction: '-',
  //         availableTime: '91385.63',
  //         contractualAvailability: '97.72',
  //         lostProduction: '-',
  //         referencePeriod: 'Aug 2026',
  //         unavailableTime: '916.07',
  //       },
  //       {
  //         actualProduction: '-',
  //         availableTime: '60276.15',
  //         contractualAvailability: '90.82',
  //         lostProduction: '-',
  //         referencePeriod: 'Sep 2026',
  //         unavailableTime: '1711.74',
  //       },
  //       {
  //         actualProduction: '-',
  //         availableTime: '-',
  //         contractualAvailability: '-',
  //         lostProduction: '-',
  //         referencePeriod: 'Oct 2026',
  //         unavailableTime: '-',
  //       },
  //       {
  //         actualProduction: '-',
  //         availableTime: '-',
  //         contractualAvailability: '-',
  //         lostProduction: '-',
  //         referencePeriod: 'Nov 2026',
  //         unavailableTime: '-',
  //       },
  //       {
  //         actualProduction: '-',
  //         availableTime: '-',
  //         contractualAvailability: '-',
  //         lostProduction: '-',
  //         referencePeriod: 'Dec 2026',
  //         unavailableTime: '-',
  //       },
  //       {
  //         actualProduction: '-',
  //         availableTime: '-',
  //         contractualAvailability: '-',
  //         lostProduction: '-',
  //         referencePeriod: 'Jan 2027',
  //         unavailableTime: '-',
  //       },
  //       {
  //         actualProduction: '-',
  //         availableTime: '-',
  //         contractualAvailability: '-',
  //         lostProduction: '-',
  //         referencePeriod: 'Feb 2027',
  //         unavailableTime: '-',
  //       },
  //       {
  //         actualProduction: '-',
  //         availableTime: '-',
  //         contractualAvailability: '-',
  //         lostProduction: '-',
  //         referencePeriod: 'Mar 2027',
  //         unavailableTime: '-',
  //       },
  //       {
  //         actualProduction: '-',
  //         availableTime: '-',
  //         contractualAvailability: '-',
  //         lostProduction: '-',
  //         referencePeriod: 'Apr 2027',
  //         unavailableTime: '-',
  //       },
  //       {
  //         actualProduction: '-',
  //         availableTime: '-',
  //         contractualAvailability: '-',
  //         lostProduction: '-',
  //         referencePeriod: 'Reference Period Total',
  //         unavailableTime: '-',
  //       },
  //       {
  //         actualProduction: '-',
  //         availableTime: '421213.18',
  //         contractualAvailability: '96.27',
  //         lostProduction: '-',
  //         referencePeriod: 'Reference Period Total',
  //         unavailableTime: '7547.95',
  //       },
  //     ],
  //   },
  // };
  return { data: _data, error, isLoading };
};